import React, { createContext, useState } from 'react';
import MaterialTable from '../../../components/materialTable';
import useSWR from 'swr';
import {
  postSeleccionable,
  putSeleccionable,
  deleteSeleccionable,
} from '../../../services/request/requestSeleccionables';
import { Fragment } from 'react';
import DialogoCRUDRegistroSeleccionable from './dialogoCRUDRegistroSeleccionable';
import { CONDICION_APLICA_GENERAL, CONDICION_APLICA_VEHICULO } from '../../../constants/constantes';

export const OPCIONES_APLICA_A = [
  { value: CONDICION_APLICA_GENERAL, label: 'General (no vehículos)' },
  { value: CONDICION_APLICA_VEHICULO, label: 'Vehículos' },
];

//Si el seleccionable no tiene aplica_a, se considera de uso general.
const obtenerAplicaA = (row) =>
  row && Array.isArray(row.aplica_a) && row.aplica_a.length > 0 ? row.aplica_a : [CONDICION_APLICA_GENERAL];

export const TablaSeleccionablesContext = createContext({
  openDialogoCRUD: false,
  setOpenDialogoCRUD: () => {},
  tituloDialogo: '',
  setTituloDialogo: () => {},
  nombre: '',
  setNombre: () => {},
  id: '',
  setId: () => {},
  conAplicaA: false,
  aplicaA: [],
  setAplicaA: () => {},
  handleAceptar: () => {},
  disableEditing: false,
  setDisableEditing: () => {},
  handleOpenAgregar: () => {},
  handleOpenModificar: () => {},
  handleOpenQuitar: () => {},
});

export default function TablaSeleccionables(props) {
  const { titulo, getData, puedeAgregar, puedeEditar, puedeEliminar, conAplicaA = false } = props;
  const { data, mutate } = useSWR(`get:${titulo}`, (key) => getData());

  const [openDialogoCRUD, setOpenDialogoCRUD] = useState(false);
  const [tituloDialogo, setTituloDialogo] = useState('');
  const [nombre, setNombre] = useState('');
  const [id, setId] = useState('');
  const [aplicaA, setAplicaA] = useState([CONDICION_APLICA_GENERAL]);
  const [disableEditing, setDisableEditing] = useState(false);

  const handleOpenAgregar = (titulo) => {
    setOpenDialogoCRUD(true);
    setTituloDialogo(titulo);
    setNombre('');
    setId('');
    setAplicaA([CONDICION_APLICA_GENERAL]);
    setDisableEditing(false);
  };

  const handleOpenModificar = (titulo, nombre, id, aplica_a) => {
    setOpenDialogoCRUD(true);
    setTituloDialogo(titulo);
    setNombre(nombre);
    setAplicaA(aplica_a);
    setDisableEditing(false);
    setId(id);
  };

  const handleOpenQuitar = (titulo, nombre, id, aplica_a) => {
    setOpenDialogoCRUD(true);
    setTituloDialogo(titulo);
    setNombre(nombre);
    setAplicaA(aplica_a);
    setDisableEditing(true);
    setId(id);
  };

  const handleAceptar = async (titulo, value, id) => {
    let context = '';
    if (titulo.includes('Colores')) context = 'colores';
    else if (titulo.includes('Condiciones de Activos')) context = 'condiciones_actuales';
    else if (titulo.includes('Tipos de Documentos')) context = 'tipo_documento_adjunto';
    if (context) {
      const datos = conAplicaA ? { value, label: value, context, aplica_a: aplicaA } : { value, label: value, context };
      if (titulo.includes('Agregar')) await postSeleccionable(datos);
      else if (titulo.includes('Modificar')) await putSeleccionable(id, datos);
      else if (titulo.includes('Eliminar')) await deleteSeleccionable(id, context);
    }
    setOpenDialogoCRUD(false);
    mutate();
  };

  const columns = [
    {
      title: 'Nombre',
      field: 'label',
    },
    {
      title: 'Aplica a',
      hidden: !conAplicaA,
      render: (row) =>
        OPCIONES_APLICA_A.filter((opcion) => obtenerAplicaA(row).includes(opcion.value))
          .map((opcion) => opcion.label)
          .join(', '),
    },
  ];

  return (
    <Fragment>
      <TablaSeleccionablesContext.Provider
        value={{
          openDialogoCRUD,
          setOpenDialogoCRUD,
          tituloDialogo,
          setTituloDialogo,
          nombre,
          setNombre,
          id,
          setId,
          conAplicaA,
          aplicaA,
          setAplicaA,
          handleAceptar,
          disableEditing,
          setDisableEditing,
          handleOpenAgregar,
          handleOpenModificar,
          handleOpenQuitar,
        }}
      >
        <MaterialTable
          title={titulo}
          is_loading={!data}
          data={data && data.data}
          columns={columns}
          filtering={false}
          grouping={false}
          searching={false}
          empty_rows={true}
          page_size={5}
          actions={[
            {
              tooltip: 'Agregar',
              icon: 'add',
              hidden: !puedeAgregar,
              onClick: (event, row) => handleOpenAgregar(`Agregar ${titulo}`),
              isFreeAction: true,
            },
            {
              tooltip: 'Editar',
              icon: 'edit',
              hidden: !puedeEditar,
              onClick: (event, row) => handleOpenModificar(`Modificar ${titulo}`, row.label, row._id, obtenerAplicaA(row)),
            },
            {
              tooltip: 'Eliminar',
              icon: 'delete',
              hidden: !puedeEliminar,
              onClick: (event, row) => handleOpenQuitar(`Eliminar ${titulo}`, row.label, row._id, obtenerAplicaA(row)),
            },
          ]}
        />
        <DialogoCRUDRegistroSeleccionable />
      </TablaSeleccionablesContext.Provider>
    </Fragment>
  );
}
